import React from 'react';
import { useMfaTimer } from '../../hooks/useMfaTimer';
import styles from './MfaCountdownTimer.module.scss';

export const MfaCountdownTimer: React.FC = () => {
  const { isTimerActive, formattedTimerDigits } = useMfaTimer();

  if (!isTimerActive) {
    return null;
  }

  return (
    <div className={styles.mfaCountdownTimer} data-testid="mfa-countdown-timer">
      Resend Code in{' '}
      <span className={styles.timerDigits}>{formattedTimerDigits}</span>
    </div>
  );
};
